// This file was auto-generated by commondatabuilder.
// Please don't edit it.

export const maxRecipients = 3;
